// форматирует дату перед её выводом на экран
const formaterDate = (val) => {
  // скорее всего лучше сделать проверку на null
  if (val !== null && val !== '') {
    const date = new Date(val)
    return date.toLocaleDateString('ru')
  } else {
    // return '--.--.--'
    return ''
  }
}

const formaterDateTime = (val) => {
  // скорее всего лучше сделать проверку на null
  if (val !== null && val !== '') {
    const date = new Date(val)
    // return date.toLocaleString('ru')
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    }
    return new Intl.DateTimeFormat('ru', options).format(date).toString()
  } else {
    // return '--.--.--'
    return ''
  }
}

export { formaterDate, formaterDateTime }
